import {
  PlanAnnualTableState,
  PlanAnnualTableAction,
  PlanAnnualTableActionTypes as ActionTypes,
} from './types';

/**
 * @summary 年次販売集計画面で管理されるStateの初期値
 */
const initialPlanAnnualTableState: PlanAnnualTableState = {
  refresh: {},
  /** Load中か */
  isLoading: false,
  /** 送信処理中か */
  isSubmitting: false,
  /** ソート番号 */
  sort: 1,
  /** 詳細検索条件 */
  searchParameter: {},
  /** 年次販売集計リスト */
  tables: [],
  /** 年次計画サマリ */
  summary: null,
  /** 年次販売集計サマリ */
  salesSummary: null,
};

const planAnnualTableReducer = (
  state: PlanAnnualTableState = initialPlanAnnualTableState,
  action: PlanAnnualTableAction,
): PlanAnnualTableState => {
  switch (action.type) {
    case ActionTypes.INIT:
      return initialPlanAnnualTableState;

    case ActionTypes.REFRESH:
      return { ...state, refresh: {} };

    case ActionTypes.LOADING:
      return { ...state, isLoading: action.payload };

    case ActionTypes.SUBMITTING:
      return { ...state, isSubmitting: action.payload };

    case ActionTypes.SET_SORT:
      return { ...state, sort: action.payload };

    case ActionTypes.SET_SEARCH_PARAMETER:
      return { ...state, searchParameter: action.payload };

    case ActionTypes.SET_TABLES:
      return { ...state, tables: action.payload };

    case ActionTypes.SET_SUMMARY:
      return { ...state, summary: action.payload };

    case ActionTypes.SET_SALES_SUMMARY:
      return { ...state, salesSummary: action.payload };

    default:
      return state;
  }
};

export default planAnnualTableReducer;
